import React, { useState, useEffect } from "react";
import { Container } from "./styles";

import mobileMenuImg from "../../assets/images/mobile-menu.png";
import ConnectWalletButton from "../ui/buttons/ConnectWalletButton";
import Logo from "../ui/Logo";
import TransactionButton from "../ui/buttons/TransactionButton";

const Header = () => {
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const pathname = window.location.pathname;
  const [color, setColor] = useState("trasparent");
  const navRef = React.useRef();

  const handleOpenMenu = () => {
    setIsOpenMenu(!isOpenMenu);
  };
  useEffect(() => {
    const handleScroll = () => {
      const show = window.scrollY > 50;
      if (show) {
        setColor("#fff");
      } else {
        setColor("transparent");
      }
    };
    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Container bgcolor={color} ref={navRef}>
      <div className="header">
        <Logo />
        <nav className="navbar__desktop">
          {pathname == "/" && (
            <ul>
              <li>
                <a href="#home">Home</a>
              </li>
              <li>
                <a href="#about">About Us</a>
              </li>
              <li>
                <a href="#tokenomics">Tokenomics</a>
              </li>
              <li>
                <a href="#roadmap">Roadmap</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="#"
                >
                  Audit
                </a>
              </li>
            </ul>
          )}
          {(pathname == "/farm" ||
            pathname == "/swap" ||
            pathname == "/dapp" ||
            pathname == "/pool") && (
            <ul>
              {/* <li>
                <a href="/dapp">Cloud Mining</a>
              </li>
              <li>
                <a href="/swap">Swap</a>
              </li>
              <li>
                <a href="/pool">Pool</a>
              </li>
              <li>
                <a href="/farm">Farm</a>
              </li> */}
            </ul>
          )}
        </nav>
        <div className="header-buttons">
          {/* <div className="select-network-button">Polygon</div> */}
          {pathname == "/" && (
            <a href="/dapp">
              <TransactionButton name="DAPP" />
            </a>
          )}
          {(pathname == "/farm" ||
            pathname == "/swap" ||
            pathname == "/dapp" ||
            pathname == "/pool") && <ConnectWalletButton />}
        </div>
        <button className="mobile-button" onClick={handleOpenMenu}>
          <img src={mobileMenuImg} alt="" />
        </button>
      </div>
      <nav className={isOpenMenu ? "navbar__mobile show" : "navbar__mobile"}>
        {pathname == "/" && (
          <ul>
            <li>
              <a href="#home" onClick={handleOpenMenu}>
                Home
              </a>
            </li>
            <li>
              <a href="#about" onClick={handleOpenMenu}>
                About Us
              </a>
            </li>
            <li>
              <a href="#tokenomics" onClick={handleOpenMenu}>
                Tokenomics
              </a>
            </li>
            <li>
              <a href="#roadmap" onClick={handleOpenMenu}>
                Roadmap
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="#"
                onClick={handleOpenMenu}
              >
                Audit
              </a>
            </li>
            <li className="button" onClick={handleOpenMenu}>
              <a href="/dapp">
                <TransactionButton name="DAPP" />
              </a>
            </li>
          </ul>
        )}
        {(pathname == "/farm" ||
          pathname == "/swap" ||
          pathname == "/dapp" ||
          pathname == "/pool") && (
          <ul>
            {/* <li>
              <a href="/dapp" onClick={handleOpenMenu}>
                Cloud Mining
              </a>
            </li>
            <li>
              <a href="/swap" onClick={handleOpenMenu}>
                Swap
              </a>
            </li>
            <li>
              <a href="/pool" onClick={handleOpenMenu}>
                Pool
              </a>
            </li>
            <li>
              <a href="/farm" onClick={handleOpenMenu}>
                Farm
              </a>
            </li> */}
            <li className="button" onClick={handleOpenMenu}>
              <ConnectWalletButton />
            </li>
          </ul>
        )}
      </nav>
    </Container>
  );
};

export default Header;
